import React, { useState } from 'react';
import './App.css';
import Autostereogram from './components/Autostereogram';
import AutostereogramControls from './components/AutostereogramControls';

/**
 * Main application component that displays an autostereogram with controls
 */
function App() {
  // States for autostereogram parameters with improved defaults
  const [depth, setDepth] = useState<number>(5);
  const [squareSize, setSquareSize] = useState<number>(0.4);
  const [separation, setSeparation] = useState<number>(30);
  const [seed, setSeed] = useState<number>(42);

  /**
   * Generates a random seed value
   */
  const generateRandomSeed = () => {
    setSeed(Math.floor(Math.random() * 100000));
  };

  return (
    <div className='App'>
      <header className='App-header'>
        <h1>Autostereogram Generator</h1>
        <p>An autostereogram (or "Magic Eye") is a 2D image that creates a 3D effect when viewed correctly.</p>
      </header>

      <main style={{ padding: '20px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <Autostereogram
            width={700}
            height={400}
            depth={depth}
            squareSize={squareSize}
            separation={separation}
            seed={seed}
          />

          <AutostereogramControls
            depth={depth}
            onDepthChange={setDepth}
            squareSize={squareSize}
            onSquareSizeChange={setSquareSize}
            separation={separation}
            onSeparationChange={setSeparation}
            seed={seed}
            onSeedChange={setSeed}
            onRandomSeed={generateRandomSeed}
          />
        </div>
      </main>

      <footer
        style={{
          marginTop: '40px',
          padding: '20px',
          textAlign: 'center',
          borderTop: '1px solid #eee',
          fontSize: '0.9em',
        }}
      >
        <p>Created with React and TypeScript. Adjust the controls to customize the autostereogram.</p>
      </footer>
    </div>
  );
}

export default App;
